import { useEffect, useRef } from "react";

// hook built to handle scrolling down to the SDK once it is
// rendered on the page
export const useOnfidoObserver = () => {
  const observerRef = useRef<MutationObserver | null>(null);

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const onfidoSdkElement = document.getElementById("onfido-sdk");
        if (onfidoSdkElement) {
          onfidoSdkElement.scrollIntoView({ behavior: "smooth" });
          observer.disconnect();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    observerRef.current = observer;

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return observerRef;
};
